import React from 'react';

import { HeaderSelectorsContainer } from './styledComponents';

export const FullScreenModalHeaderSelectors = (props) => (
  <HeaderSelectorsContainer>{props.children}</HeaderSelectorsContainer>
);

export default FullScreenModalHeaderSelectors;
